<div class="text-section" [style.max-width]="section.width + 'px'" [class.dark]="darkGalleryBackground">
  <h2
    [style.fontFamily]="
      (section.text_title_typography.font_family || gallery.default_title_typography?.font_family) + ', AkkuratLL'
    "
    [style.color]="section.text_title_typography?.font_color || gallery.default_title_typography?.font_color"
    class="{{ titleFontSize }}"
  >
    {{ section.text_title }}
  </h2>
  <p
    [style.fontFamily]="
      (section.text_paragraph_typography.font_family || gallery.default_paragraph_typography?.font_family) +
      ', AkkuratLL'
    "
    [style.color]="section.text_paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color"
    class="{{ paragraphFontSize }}"
    [innerHTML]="textParagraph"
  ></p>
</div>
